import classnames from 'classnames';
import React from 'react';
import { SVGProps } from './SVGProps';

function GoogleExternalLoginSVG({ className, ...rest }: SVGProps) {
	return (
		<svg viewBox="0 0 32 32" className={classnames('roc-icon roc-icon-google-external-login', className)} {...rest}>
			<path
				fill="#fff"
				style={{ fill: 'var(--color1, #fff)' }}
				d="M32 16.374c0 9.129-6.354 15.626-15.738 15.626-8.997 0-16.262-7.148-16.262-16s7.266-16 16.262-16c4.38 0 8.066 1.581 10.905 4.187l-4.426 4.187c-5.79-5.497-16.557-1.368-16.557 7.626 0 5.581 4.531 10.103 10.079 10.103 6.439 0 8.852-4.542 9.233-6.897h-9.233v-5.503h15.482c0.151 0.819 0.256 1.606 0.256 2.671z"
			></path>
		</svg>
	);
}

export default GoogleExternalLoginSVG;
